import * as moment from 'moment'
import * as React from 'react'
import Circle from '../icons/ui/Circle'

interface IAuditLog {
  log: string
  date: Date
}

interface ITripHistoryAuditLogProps {
  logs: IAuditLog[]
}

class TripHistoryAuditLog extends React.Component<ITripHistoryAuditLogProps, any, any> {
  public render() {
    return <React.Fragment>{this.props.logs.map(this.log)}</React.Fragment>
  }

  private log = (log: IAuditLog, index: number): any => {
    const date = moment(log.date)
    return (
      <React.Fragment key={`th-audit-log-${index}`}>
        <div className='col-12 font-grey flex items-center mt02'>
          <Circle height={6} width={6} className='svg-green mr2' />
          <div className='flex-auto'>
            <div className='col-12 flex'>
              <div className='col-4 h6'>{log.log}</div>
              <div className='col-8 flex justify-around'>
                <span className='h6'>{date.format('HH:mm a')}</span>
                <span className='h6'>{date.format('MMMM DD, YYYY')}</span>
              </div>
            </div>
          </div>
        </div>
        {this.logDivider(index)}
      </React.Fragment>
    )
  }

  private logDivider = (logIndex: number): any => {
    if (logIndex < this.props.logs.length - 1) {
      return <div className='trip-history-audit-log-divider bl-green' />
    }
  }
}

export default TripHistoryAuditLog



// WEBPACK FOOTER //
// ./src/components/trips/TripHistoryAuditLog.tsx